import { Injectable } from '@angular/core';
import { Observable, Subject } from "rxjs";
import {HttpClient, HttpHeaders} from '@angular/common/http';
import * as moment from 'moment';
import { fuseConfig } from '../../fuse-config';
@Injectable({
    providedIn: 'root'
})
export class ReportsService {
    private subject;
    public building = null;
    constructor(private http: HttpClient) {
      this.subject = new Subject();
    }
    
    
    subscribe(next, error?, complete?): any {
        return this.subject.subscribe(next, error, complete);
    }

    getGuestTypes(): Observable<any> {
        return this.http.get(fuseConfig.url + '/shared/guest_type');
    }

    getBuildingGates(building): Observable<any> {
        return this.http.get(fuseConfig.url + '/shared/getBuildingGates/'+building);
    }

    getAccessReport(form): Observable<any> {
        const data = {...form};
        data.fromDate = data.fromDate ? moment(data.fromDate).format('YYYY-MM-DD') : data.fromDate;
        data.toDate = data.toDate ? moment(data.toDate).format('YYYY-MM-DD') : data.toDate;
        return this.http.post(fuseConfig.url + '/shared/reports/access', data);
    }

    // LPR: ¿el Visitor Log de este scope traera la salida de control vehicular? Lo pregunta
    // la pantalla ANTES de buscar, para mostrar el filtro "Salida control vehicular". Mismo
    // scope que getAccessReport: uno solo de building, gate o unit. Responde
    // {lpr: {checkout}}; un API sin LPR responde 404 y quien llama lo toma como false.
    getAccessReportLprStatus(scope: { building?: string, gate?: string, unit?: string }): Observable<any> {
        const params: any = {};
        ['building', 'gate', 'unit'].forEach(key => {
            if (scope && scope[key]) {
                params[key] = scope[key];
            }
        });
        return this.http.get(fuseConfig.url + '/shared/reports/access/lpr', { params });
    }

    getAccessMonitoringReport(form): Observable<any> {
        const data = {...form};
        data.fromDate = data.fromDate ? moment(data.fromDate).format('YYYY-MM-DD') : data.fromDate;
        data.toDate = data.toDate ? moment(data.toDate).format('YYYY-MM-DD') : data.toDate;
        return this.http.post(fuseConfig.url + '/shared/reports/access-monitoring', data);
    }

    // Opciones del filtro "Puerta" de Access Monitoring: las puertas de TODOS los paneles
    // del sitio (CDVI y PDK) y sus lectores QR, [{id, name, kind: 'door'|'qr_reader',
    // gateName?}]. No depende de que el sitio tenga goutru_connector.
    getAccessMonitoringDoors(building: string): Observable<any> {
        return this.http.get(fuseConfig.url + '/shared/reports/access-monitoring/doors/' + building);
    }

    getTagsReport(form): Observable<any> {
        const data = {...form};
        data.expDateFrom = data.expDateFrom ? moment(data.expDateFrom).format('YYYY-MM-DD') : undefined;
        data.expDateTo = data.expDateTo ? moment(data.expDateTo).format('YYYY-MM-DD') : undefined;
        data.dueDateFrom = data.dueDateFrom ? moment(data.dueDateFrom).format('YYYY-MM-DD') : undefined;
        data.dueDateTo = data.dueDateTo ? moment(data.dueDateTo).format('YYYY-MM-DD') : undefined;
        data.cardFacility = data.cardFacility ? data.cardFacility : undefined;
        data.cardCodeFrom =  data.cardCodeFrom ? data.cardCodeFrom : undefined;
        data.cardCodeTo =  data.cardCodeTo ? data.cardCodeTo : undefined;
        return this.http.post(fuseConfig.url + '/shared/reports/tags', data);
    }

    getPhotoEvent(gtc_port, eventId, camera?: number): Observable<any> {
        // camera=2 pide la segunda camara. Sin el, el backend sirve la primera, que es lo
        // que necesitan los eventos del connector (una sola imagen por evento).
        const query = camera === 2 ? '?camera=2' : '';
        return this.http.get( fuseConfig.url + '/shared/monitor/photoEvent/' + gtc_port + '/' + eventId + query);
    }

    getScanImage(camera, scanId, type): Observable<any> {
        return this.http.get(fuseConfig.url + '/shared/getScanImage/' + scanId + '/' + type + '/' + camera);
    }

    getSmartKioskReport(form, building:string): Observable<any> {
        const data = {...form};
        data.fromDate = data.fromDate ? moment(data.fromDate).format('YYYY-MM-DD') : undefined;
        data.toDate = data.toDate ? moment(data.toDate).format('YYYY-MM-DD') : undefined;
        data.action = data.action ? Number(data.action) : undefined;
        return this.http.post(fuseConfig.url + '/buildingAdmin/kioskSmart/eventLogs/'+building, data);
    }

    getSmartKioskImage(building, event): Observable<any> {
        return this.http.get(fuseConfig.url + '/buildingAdmin/kioskSmart/eventLogs/' + building + '/' + event);
    }

    postSecurityIncident(buildingId, body): Observable<any> {
        return this.http.post( fuseConfig.url + `/security/${buildingId}/incident`, body);
    }

    getSecurityIncident(buildingId: string, filters: string): Observable<any> {
        return this.http.get(fuseConfig.url + `/security/${buildingId}/incident${filters}`);
    }

    getSecurityIncidentUsers(buildingId: string): Observable<any> {
        return this.http.get(fuseConfig.url + `/security/${buildingId}/incidentUsers`);
    }

    updateIncidentStatus(buildingId: string, incidentId: string, status: string): Observable<any> {
        return this.http.put(
            fuseConfig.url +
                `/security/${buildingId}/incident/${incidentId}/updateStatus?status=${status}`,
            {}
        );
    }

    getIncidentDetails(buildingId: string, incidentId: string): Observable<any> {
        return this.http.get(
            fuseConfig.url + `/security/${buildingId}/incident/${incidentId}`
        );
    }

    addIncidentComment(buildingId: string, incidentId: string, body: {comment: string}): Observable<any> {
        return this.http.post(
            fuseConfig.url + `/security/${buildingId}/incident/${incidentId}/createComment`,
            body
        );
    }

    getIncidentComments(buildingId: string, incidentId: string): Observable<any> {
        return this.http.get(
            fuseConfig.url + `/security/${buildingId}/incident/${incidentId}/comments`
        );
    }

    getVisitorLogSecurityList(buildingId: string): Observable<any> {
        return this.http.get(
            fuseConfig.url + `/shared/reports/access/${buildingId}/securityList`
        ) as Observable<{
            security: [{ user_security: string; user_security_name: string }];
        }>;
    }
    
    getEventReports(building: string, filterParam: string): Observable<any> {
        return this.http.get(fuseConfig.url + `/buildingAdmin/eventReport/${building}?${filterParam}`);
    }
    
    getGuestReport(building: string, query: string): Observable<any> {
        return this.http.get(fuseConfig.url + `/buildingAdmin/${building}/guestReport?${query}`);
    }

    // LPR: reporte "Control vehicular (LPR)". Es POST y los filtros van en el body, como en
    // Visitor Logs: la placa buscada no viaja en la URL. `filters` ya trae fromDate y toDate
    // como dias de calendario del sitio (lprReportBody). Un API sin LPR responde 404 (HTML,
    // sin message) y uno que lo niega 403: quien llama decide no avisar.
    getLprReport(building: string, filters: any): Observable<any> {
        return this.http.post(fuseConfig.url + `/buildingAdmin/lpr/report/${building}`, filters);
    }

    // LPR: "Lecturas de la camara". Camaras LPR que el sitio puede consultar, cada una con su
    // catalogo de filtros y si el agente de su conector esta conectado, mas la zona del
    // sitio. 403 = la sesion no es manager del sitio; 404 = el API no tiene la ruta.
    getLprCameras(building: string): Observable<any> {
        return this.http.get(fuseConfig.url + `/buildingAdmin/lpr/cameras/${building}`);
    }

    // LPR: una pagina de lecturas de UNA camara, consultada en vivo (la API espera al agente
    // y responde en el mismo POST, hasta ~40 s). POST para que la placa buscada no vaya en
    // la URL. Desuscribirse corta la peticion: el API borra el pedido y avisa al agente.
    getLprCameraReads(building: string, body: any): Observable<any> {
        return this.http.post(fuseConfig.url + `/buildingAdmin/lpr/camera-reads/${building}`, body);
    }
}